import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Grid,
  CircularProgress,
} from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './Style';
import Link from '@mui/material/Link';
import Services from '../../services/Serivces';
import { Icons } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import useCustomHook from '../../hooks';

export default function UploadDialog({ open, setOpen, row, userId }) {
  const classes = useStyles();
  const methods = useForm();

  const { loading, setLoading, beforeUlpoadList, setBeforeUlpoadList } = useCustomHook();
  useEffect(() => {
    open && getUploadFiles();
  }, [open]);
  // فایل های آپلود شده را برمیگرداند
  const getUploadFiles = () => {
    const params = {
      offset: 0,
      size: 100,
      documentItemId: row?.docItemId,
    };
    Services.getMetaData(row?.thingUserId, params)
      .then((res) => {
        setBeforeUlpoadList(res.result);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const clearFile = () => {
    setTimeout(() => {
      setBeforeUlpoadList([]);
      setLoading(true);
    }, 500);
  };
  return (
    <FormProvider {...methods}>
      <Dialog
        onClose={() => {
          setOpen(false);
          clearFile();
          setLoading(false);
        }}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="sm"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          className={classes.title}
          onClose={() => {
            setOpen(false);
            clearFile();
            setLoading(false);
          }}
        >
          مدارک شماره سند {row?.documentId}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
              clearFile();
              setLoading(false);
            }}
            size="large">
            <Icons icon='Close' color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className={clsx(
            classes.dialog,
            (!loading && !beforeUlpoadList.length) || loading ? classes.noFile : '',
          )}
        >
          {!loading && !beforeUlpoadList.length && <b>تاکنون مدرکی پیوست نشده است</b>}
          {loading && (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress size={24} />
            </div>
          )}
          <Grid spacing={2} item className={classes.contentFile}>
            <Grid item alignItems="center" spacing={2} className={classes.containerFileUpload}>
              {beforeUlpoadList.length > 0 &&
                beforeUlpoadList.map((item, index) => {
                  return (
                    <Link className={classes.fileLink} href={item.hash} target="_blank">
                      <Icons icon='Document' color="#263238" size="25" />
                      مدرک شماره {index + 1}
                    </Link>
                  );
                })}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </FormProvider>
  );
}
